import React from 'react';
import classnames from 'classnames';
import { IconSize, } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './StatisticsBarItem.scss';
var StatisticsBarItem = function (_a) {
    var IconComponent = _a.icon, label = _a.label, className = _a.className;
    return (React.createElement(Flex, { inline: true, className: classnames(s['root'], className), alignItems: "center" },
        React.createElement(IconComponent, { className: s['icon'], size: IconSize.SMALLER, disableDefaultColors: true }),
        React.createElement("span", null, label)));
};
StatisticsBarItem.displayName = 'StatisticsBarItem';
export default StatisticsBarItem;
//# sourceMappingURL=StatisticsBarItem.js.map